import { createContext } from 'react';
import { UserProfileResource } from '../../util/resources/UserProfile';
import { JobApplicationResource } from '../../util/resources/JobApplication';
import { UserProfileMetadataResource } from 'util/resources/UserProfileMetadata';

const defaultValues: {
  userProfile: UserProfileResource | null;
  lastJobApplication: JobApplicationResource | null;
  otherJobApplications: JobApplicationResource[];
  userProfileMetadata?: UserProfileMetadataResource;
  hasPreferences: {
    expectedCompensation: boolean;
    ageGroups: boolean;
    desiredJobs: boolean;
    desiredLocations: boolean;
    desiredRoles: boolean;
    startDate: boolean;
    schedule: boolean;
  };
} = {
  userProfile: null,
  lastJobApplication: null,
  otherJobApplications: [],
  userProfileMetadata: null,
  hasPreferences: {
    expectedCompensation: false,
    ageGroups: false,
    desiredJobs: false,
    desiredLocations: false,
    desiredRoles: false,
    startDate: false,
    schedule: false,
  },
};
export const ContactSidebarContext = createContext(defaultValues);
